<template>
  <div>
    <section class="content-header">
      <h1>
        แก้ไขผู้ให้บริการ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> แก้ไขผู้ให้บริการ
          </a>
        </li>
        <li class="active">แก้ไขผู้ให้บริการ</li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-xs-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">ข้อมูลทั่วไป</h3>
            </div>
            <div class="box-header">
              <el-form
                size="mini"
                :label-position="label_position"
                label-width="150px"
                :model="operator_info"
                ref="ruleForm"
                class="demo-ruleForm"
              >
                <div class="row">
                  <div class="col-xs-12">
                    <el-form-item label="ชื่อ" required>
                      <el-input clearable v-model="operator_info.first_name"></el-input>
                    </el-form-item>
                    <el-form-item label="นามสกุล" required>
                      <el-input clearable v-model="operator_info.last_name"></el-input>
                    </el-form-item>
                    <el-form-item label="เบอร์โทรศัพท์" required>
                      <el-input clearable v-model="operator_info.phone_number" @keypress.native="isNumberKey"  show-word-limit maxlength="10"></el-input>
                    </el-form-item>
                    <el-form-item label="อีเมล (E-mail)" required>
                      <el-input show-email v-model="operator_info.email" @keypress.native="checkCharater"></el-input>
                    </el-form-item>
                    <el-form-item label="ชื่อผู้ให้บริการ" required>
                      <el-select
                        v-model="operator_info.company_provider_id"
                        placeholder="โปรดเลือกชื่อผู้ให้บริการ"
                        @change="selectList"
                      >
                        <el-option
                          v-for="item in this.options"
                          :label="item.provider_name"
                          :key="item.id"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
         <div class="col-xs-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">เปลี่ยนรูปโปรไฟล์</h3>
            </div>
            <div class="box-body" align="center">
              <div id="preview" style="height: 347px">
                <img v-if="preview_img" :src="preview_img" />
              </div>
              <br />
              <el-upload
                type="file"
                class="upload-demo"
                ref="file"
                action="#"
                :on-change="onFileChange"
                :show-file-list="false"
                :limit="1"
                :auto-upload="false"
                accept="image/jpeg,image/png"
              >
                <el-button
                  slot="trigger"
                  size="small"
                  type="primary"
                >เลือกรูปภาพ</el-button>
              </el-upload>     
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">สิทธิการจัดการ</h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="row" v-if="checkType == 'mobile'">
                    <div class="col-sm-4">
                      <label for="จัดการข้อมูลโทรศัพท์เคลื่อนที่">เมนูจัดการข้อมูลรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่</label>
                    </div>
                    <div class="col-sm-8">
                      <el-checkbox-group v-model="operator_info.role_permission.Manage_mobile">
                        <el-checkbox style="width:165px;" label="add">เพิ่มรายการส่งเสริมการขาย</el-checkbox>
                        <el-checkbox style="width:165px;" label="edit">แก้ไขรายการส่งเสริมการขาย</el-checkbox>
                        <el-checkbox style="width:165px;" label="delete">ลบรายการส่งเสริมการขาย</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="row" v-if="checkType == 'broadband'">
                    <div class="col-sm-4">
                      <label for="จัดการข้อมูลอินเทอร์เน็ตประจำที่" >เมนูจัดการข้อมูลรายการส่งเสริมการขายอินเทอร์เน็ตความเร็วสูงประจำที่</label>
                    </div>
                    <div class="col-sm-8">
                      <el-checkbox-group v-model="operator_info.role_permission.Manage_internet">
                        <el-checkbox style="width:165px;" label="add">เพิ่มรายการส่งเสริมการขาย</el-checkbox>
                        <el-checkbox style="width:165px;" label="edit">แก้ไขรายการส่งเสริมการขาย</el-checkbox>
                        <el-checkbox style="width:165px;" label="delete">ลบรายการส่งเสริมการขาย</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <label
                        for="จัดการข้อมูลอินเทอร์เน็ตประจำที่"
                      >เมนูนำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกับกำดูแล</label>
                    </div>
                    <div class="col-sm-8">
                      <el-checkbox-group v-model="operator_info.role_permission.Upload_save">
                        <el-checkbox style="width:250px;" label="true">อนุญาต</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <label for="จัดการข้อมูลอินเทอร์เน็ตประจำที่" >รายงานจำนวนผู้เข้าชมข้อมูลรายการส่งเสริมการขายจำแนกตามการให้บริการ</label>
                    </div>
                    <div class="col-sm-8">
                      <el-checkbox-group v-model="operator_info.role_permission.Reportview_promotion">
                        <el-checkbox style="width:165px;" label="true">อนุญาต</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <label>รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ</label>
                    </div>
                    <div class="col-sm-8">
                      <el-checkbox-group v-model="operator_info.role_permission.User_behavior">
                        <el-checkbox style="width:165px;" label="true">อนุญาต</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <label>เมนูแจ้งปัญหาการใช้งาน</label>
                    </div>
                    <div class="col-sm-8">
                      <el-checkbox-group v-model="operator_info.role_permission.Contact_admin">
                        <el-checkbox style="width:165px;" label="true">อนุญาต</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="box-footer">
                    <el-button style="float: left" type="secondary" @click="back">ยกเลิก</el-button>
                    <el-button style="float: right" type="primary" @click="submitForm()">บันทึก</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      file:null,
      label_position: "top",
      checkList: [],
      checkType: null,
      ruleForm: {
        permissions: {
          Manage_mobile: ["Manage_mobile"],
          Manage_internet: ["Manage_internet"],
          Upload_save: ["Upload_save"],
          Reportview_promotion: ["Reportview_promotion"],
          User_behavior:['User_behavior']
        },
        name: "",
        lastname: "",
        phoneNumber: "",
        email: "",
        admin_id: "",
        provider: null
      }
    };
  },
  created() {
    this.listing();
  },
  mounted(){
    if(!this.operator_info) this.$router.push({name : 'Manage_operator'})
    this.checkType = this.operator_info.provider_type
  },
  computed: {
    ...mapState({
      options: store => store.Manage_operator.select_lists,
      operator_info : store => store.Manage_operator.operator_info,
      preview_img : store => store.Manage_operator.preview_img
    })
  },
  methods: {
    ...mapActions({
      listing: "Manage_operator/getAvailableOperator",
      update: "Manage_operator/edit_permission"
    }),
    selectList(id) {
      this.ruleForm.provider = parseInt(id)
      let selected = this.options.filter(item => item.id == id)
      this.checkType = selected ? selected[0].provider_type : this.operator_info.provider_type
    },
    submitForm() {
      if(this.operator_info.first_name.length<4){
        this.$confirm("กรุณากรอกชื่อ ความยาว 4 - 50 ตัวอักษร", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if(this.operator_info.last_name.length<4){
        this.$confirm("กรุณากรอกนามสกุล ความยาว 4 - 50 ตัวอักษร", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if (this.operator_info.phone_number.length !== 10){
        this.$confirm("กรุณากรอกหมายเลขโทรศัพท์ เป็นตัวเลข 10 หลัก", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if (!this.operator_info.email.length){
        this.$confirm("กรุณากรอกอีเมล", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else {
        let forminfo = this.operator_info
            forminfo.pickType = this.checkType
        let formData = new FormData();
            formData.append("typeFile", "profile");
            formData.append("formdata", JSON.stringify(forminfo));
        if (this.file) formData.append("file", this.file);
        this.update(formData);
      }
    },
    onFileChange(e) {
      this.$refs.file.clearFiles()
      this.file = e.raw;
      this.$store.commit('Manage_operator/SET_PREVIEW_IMG', URL.createObjectURL(this.file))
    },
    back(){
      this.$router.push({name : 'Manage_operator'})
    }
  }
};
</script>
